<template lang="pug">
  section.section-param(id="home" class="mx-auto")
    v-container.container-hs(fluid)
      .title-style-hs
        p.text-front-hs Аутстафф
        p.text-back-hs IT-СПЕЦИАЛИСТОВ
      .subtitle-style
        h1.text-hs
          | Надежно и эффективно
      v-card-actions.home-actions-style.d-flex
          v-btn.text-none.primary-button-style(@click="navigate('#registration')")
            | Оставить заявку
</template>

<script>

export default {
  name: "HomeSection",
  methods: {
    navigate(link) {
      this.$vuetify.goTo(link, {offset:-10})
    },
  }
}
</script>

<style scoped lang="sass">
  @import "ui/scss/variables.scss"
  @import "ui/scss/colors.scss"

  @media(max-width: $xxsOnly)
    .text-front-hs
      font-size: 40px !important

    .text-back-hs
      font-size: 23px !important

  @media(max-width: $xsOnly)
    .title-style-hs
      margin-top: 200px !important

    .container-hs
      background-image: url("~@/assets/xsFonSlideFirst.png") !important
      background-position: center

    .text-hs
      margin-top: 80px
      line-height: 120% !important

    .list-hs
      line-height: 120%
      ::marker
        font-size: 14px !important

    .card-img
      margin-bottom: 16%

    .card-hs
      margin-bottom: 46px

    .col-img-left
      padding-left: 0
      padding-right: 15px
    .col-img-center
      padding-left: 30px
      padding-right: 30px
    .col-img-end
      padding-left: 15px
      padding-right: 0

  @media(max-width: $smAndDown)
    .text-hs
      font-size: 24px
      margin-bottom: 18px

    .card-hs
      flex-wrap: wrap !important

    .list-card-hs
      width: 100%
      max-width: 500px
      margin-top: 0 !important
      margin-left: 6px

    .list-hs
      font-size: max(calc(10px + 1vw), 14px)
      padding-left: 0
      color: $greyText
      margin-left: -1px
      ::marker
        font-size: 13px

    .li-margin
      margin-bottom: 14px

    .li-margin-last-row
      margin-bottom: 14px

    .li-style
      list-style-type: '•'
      padding-inline-start: 0.5ch

    .text-back-hs
      margin-bottom: max(4vw, 4%) !important

    .card-img
      max-width: 1000px !important
    .row-img
      margin-top: 2px
      margin-left: $marginMax !important
      margin-right: $marginMax !important

  @media(min-width: $smOnlyStart) and (max-width: $smOnlyEnd)
    .card-img
      margin-bottom: max(11%, 30px)
    .list-hs
      line-height: 1.5

    .text-hs
      margin-top: 7%

    .card-hs
      margin-bottom: 50px

  @media(min-width: $smAndUp)
    .text-hs
      font-size: calc(21px + 1.5vw)

    .col-img-left
      padding-left: 0
      padding-right: 0
    .col-img-center
      padding-left: 0
      padding-right: 0
    .col-img-end
      padding-left: 0
      padding-right: 0

    .subtitle-style
      margin-top: 6%

  @media(min-width: $smOnlyStart) and (max-width: $mdOnlyEnd)
    .container-hs
      background-size: contain !important
      margin-top: 3%

  @media(min-width: $mdOnlyStart) and (max-width: $mdOnlyEnd)
    .card-img
      max-width: $maxWidthContent !important
      margin-bottom: 9%

    .list-card-hs
      max-width: 500px
      margin-right: 20px
      .list-hs
        font-size: calc(17px + 0.1vw)
        margin-left: -9px

    .card-hs
      margin-bottom: 4%

  @media(min-width: $mdAndUp)
    .list-mr-helper
      margin-right: 16px

    .list-hs
      line-height: 1.1

    .li-margin
      margin-bottom: 20px

  @media(min-width: $lgOnlyStart) and (max-width: $lgOnlyEnd)
    .list-hs
      font-size: min(calc(3px + 1.2vw), 22px)

  @media(min-width: $lgOnlyStart) and (max-width: 1500px)
    .list-hs
      margin-left: calc(1.5% - 13px)

  @media(min-width: 1501px)
    .list-hs
      margin-left: calc(1.7% - 14px)

  @media(max-width: $lgAndDown)
    .list-card-hs
      margin-top: 20px

  @media(min-width: $lgAndUp)
    .card-hs
      margin-bottom: 7%

    .card-img
      display: none

    .list-card-hs
      max-width: 420px
      width: 100%

  @media(min-width: $xl)
    .list-hs
      font-size: min(calc(18px + 0.15vw), 24px)

  @media (min-width: $xxl)
    .container-hs
      max-width: $maxWidthContainer
      margin: auto

  @media (min-width: $xxxl)
    .text-hs
      margin-top: 7%
      margin-bottom: 2%
      font-size: 80px

  .container-hs
    background-image: url("~@/assets/firstSlide.svg")
    background-position: top
    background-repeat: no-repeat
    background-size: cover
    min-width: $minWigthElement

  .title-style-hs
    margin-left: $marginMaxL
    display: flex
    max-width: $maxWidthContent
    margin-top: min(23%, 700px)

  .subtitle-style
    margin-left: $marginMaxL
    margin-bottom: 1%
    display: flex
    max-width: $maxWidthContent
    background-color: transparent
    align-items: flex-start

  .home-actions-style
    margin-left: $marginMaxL
    margin-bottom: 4%
    display: flex
    max-width: $maxWidthContent
    background-color: $btnColor
    align-items: flex-start

  .primary-button-style
    elevation: 0
    color: $white
    font: $btnFont
    background: $btnColor
    letter-spacing: 0.01em
    width: 191px
    margin-bottom: 16px
    margin-top: 6px

  .text-hs
    font-style: normal
    font-weight: 400
    line-height: 100%
    letter-spacing: .01em
    font-family: GothamProClassic

  .row-mt
    margin-top: 0

  .card-hs
    flex-wrap: nowrap
    max-width: $maxWidthContent
    display: flex
    margin-left: $marginMax
    margin-right: $marginMax
    background-color: transparent
  .list-card-hs
    justify-self: center
    align-self: end
    background-color: transparent
  .list-hs
    font-weight: 100
    font-family: HelveticaLite

  .img-h150-w190
    max-height: 150px
    max-width: 190px
  
  .img-h100-w80
    max-height: 100px
    max-width: 80px

  .img-h100-w190
    max-height: 100px
    max-width: 190px

  .img-h100-w190
    max-height: 100px
    max-width: 190px

  .img-h200-w190
    max-height: 200px
    max-width: 190px

  .card-img-lg
    max-width: 500px
    min-height: 100px
    min-width: 300px
    background-color: transparent
    justify-self: center
    align-self: end
    margin-bottom: 2px
    margin-left: auto

  .card-img
    max-width: 500px
    min-width: 300px
    background-color: transparent
    justify-self: center
  .row-img
    box-sizing: border-box
    max-width: 100%
    margin-left: $marginMax
    margin-right: $marginMax
  .col-img
    align-self: center
    display: grid
  .col-img-left
    justify-content: start
  .col-img-center
    justify-content: center
  .col-img-end
    justify-content: end
    
  .zoom-efect
    transform: scale(1.05)

  @font-face
    font-family: "Helvetica"
    src: local("Helvetica"), url(~@/assets/fonts/Helvetica/Helvetica.ttf) format("truetype")
  @font-face
    font-family: "HelveticaLite"
    src: local("HelveticaLite"), url(~@/assets/fonts/Helvetica/HelveticaNeue.ttf) format("truetype")

  .text-front-hs
    position: absolute
    z-index: 1
    max-width: $maxWidthContent
    align-self: end
    font-style: normal
    letter-spacing: 0.01em
    color: $black
    font-weight: 400
    line-height: 120%
    font-family: GothamProMedium
    font-size: min(calc(13px + 10vw), 210px)
    margin-bottom: 4px

  .text-back-hs
    position: absolute
    max-width: $maxWidthContent
    align-self: center
    font-style: normal
    font-weight: 400
    font-family: GothamProMedium
    letter-spacing: 0.01em
    background: $titleBack
    -webkit-background-clip: text
    -webkit-text-fill-color: transparent
    -webkit-touch-callout: none
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    user-select: none

    font-size: min(calc(7px + 6.5vw), 133px)
    margin-bottom: min(45px, 3vw)

  .max-width-ing
    max-width: 60px !important

</style>